import React, { useState } from 'react';
import { Button, CircularProgress, TextField } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import messages from './messages';
import ConfirmationModal from './ConfirmationModal';

import './styles.scss';

const DoctorReportForm = ({
  addReport,
  addReportLoading,
  doctorName,
  setDoctorName,
  report,
  setReport,
}: {
  addReport: any;
  addReportLoading: boolean;
  doctorName: string;
  setDoctorName: (doctorName: string) => void;
  report: string;
  setReport: (report: string) => void;
}) => {
  const translate = useTranslate();
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleDoctorNameInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setDoctorName(event.target.value);
  };

  const handleReportTextareaChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setReport(event.target.value);
  };

  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (doctorName === '' || report === '') {
      setOpenModal(true);
    } else {
      addReport();
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <ConfirmationModal
        handleClose={handleCloseModal}
        open={openModal}
        confirmationFunction={addReport}
        loading={addReportLoading || false}
      />
      <form onSubmit={handleFormSubmit} className="form">
        <TextField
          className="input"
          id="doctor-name"
          label={translate(messages.inputLabel)}
          value={doctorName}
          variant="outlined"
          onChange={(event) => handleDoctorNameInputChange(event)}
        />
        <TextField
          className="textarea"
          id="report"
          label={translate(messages.textareaLabel)}
          multiline
          rows={8}
          value={report}
          variant="outlined"
          onChange={(event) => handleReportTextareaChange(event)}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="button"
          disabled={addReportLoading}
        >
          {addReportLoading ? (
            <CircularProgress size="24.5px" />
          ) : (
            translate(messages.buttonText)
          )}
        </Button>
      </form>
    </>
  );
};

export default DoctorReportForm;
